//class variables
const pausedClass = 'paused';
const doneClass = 'done';
const activeClass = 'active';

//timing variables (warning: changes to the timing also needs to be applied to the scss variables of the same name in top-teaser.scss)
const slideInterval = 5000;
const pauseTime = 10000;

window.addEventListener('DOMContentLoaded', () => {
    //fetch topTeaser slides and indicators
    const topTeaser = $('.topTeaser');
    const teaserSlides = topTeaser.find('.teaserslide');
    const indicators = $('.topTeaser-indicators > li');
    const navigatePrevious = topTeaser.find('.navigatePrevious');
    const navigateNext = topTeaser.find('.navigateNext');

    //abort if none
    if(!teaserSlides.length){
        return;
    }

    //get initial slide and indicator
    let current = 0;
    let currentSlide = teaserSlides.eq(current);
    let currentIndicator = indicators.eq(current);
    let loading;

    /**
     * show next topTeaser slide
     * @param {number}  [showIndex] Index of slide to show if specific, otherwise next of current
     * @param {boolean} [pause]     Shortly pause autoplay after slide change
     */
    const showNextSlide = function (showIndex = undefined, pause = false) {
        //cancel previous loading process if any
        if (loading) {
            window.clearTimeout(loading);
        }

        //detect target slide index
        const goToIndex = (showIndex >= 0 ? showIndex : current + 1) % teaserSlides.length;
        const goLeft = (goToIndex < current);

        //remove classes from current slide and indicator
        currentSlide.removeClass(activeClass);
        currentIndicator.removeClass(activeClass);
        currentIndicator.removeClass(pausedClass);

        //remove done class from indicators right of target slide indicator
        if (goLeft) {
            indicators.each((i, el) => {
                if (i >= goToIndex) {
                    $(el).removeClass(doneClass);
                }
            });
        }

        //set target slide and indicator as current
        current = goToIndex;
        currentSlide = teaserSlides.eq(current);
        currentIndicator = indicators.eq(current);

        //do a short wait for browser updates to happen under certain conditions to make sure css transitions work properly
        loading = window.setTimeout(() => {
            //add classes to new current slide and indicator
            currentSlide.addClass(activeClass);
            currentIndicator.addClass(activeClass);
            if(pause){
                currentIndicator.addClass(pausedClass);
            }

            //add done class to indicators left of new current slide indicator
            indicators.each((i, el) => {
                if (i < current) {
                    $(el).addClass(doneClass);
                }
            });

            //continue autoplay, but pause first if needed
            loading = window.setTimeout(showNextSlide, pause ? slideInterval + pauseTime : slideInterval);
        }, (showIndex >= 0 || pause || goLeft) ? 25 : 0);
    };

    const showPreviousSlide = function(pause = false){
        showNextSlide(current === 0 ? teaserSlides.length - 1 : current - 1, pause);
    };

    //init first slide
    currentSlide.addClass(activeClass);

    //if only one slide, set indicator to done to prevent indicator animation, and stop here
    if (teaserSlides.length === 1){
        currentIndicator.addClass(activeClass).addClass(doneClass);
        navigatePrevious.addClass('hide');
        navigateNext.addClass('hide');
        return;
    }

    //bind indicator click events
    indicators.on('click', e => {
        const indicator = $(e.target).closest('.topTeaser-indicators > li');
        showNextSlide(indicator.index(), true);
    });

    navigatePrevious.on('click', e => {
        showPreviousSlide(true);
    });
    navigateNext.on('click', e => {
        showNextSlide(undefined, true);
    });

    //add swipe handling
    let touchstartX = null;
    let touchendX = 0;
    let swipeThreshold = 20;
    const checkDirection = function() {
        if (touchstartX === null || Math.abs(touchendX - touchstartX) < swipeThreshold) {
            return;
        }
        if (touchendX < touchstartX) {
            //next slide
            showNextSlide(undefined, true);
        }
        else if (touchendX > touchstartX) {
            //previous slide
            showPreviousSlide(true);
        }
    }
    document.addEventListener('touchstart', e => {
        if (!e.target.closest('.topTeaser')) {
            touchstartX = null;
            return;
        }
        touchstartX = (e.changedTouches || e.touches)[0]?.screenX || null;
    });
    document.addEventListener('touchend', e => {
        if (touchstartX === null) {
            return;
        }
        touchendX = (e.changedTouches || e.touches)[0].screenX;
        checkDirection();
    });

    //init first indicator
    currentIndicator.addClass(activeClass);

    //start autoplay
    loading = window.setTimeout(showNextSlide, slideInterval);
});
